import { getStore } from '../../reducers';
import { createSelector } from '@reduxjs/toolkit';

const getPreview = createSelector(getStore, (state) => state.preview);

export const getModal = createSelector(getPreview, (preview) => preview.modal);

export const getInProgress = createSelector(getPreview, (preview) => preview.inProgress);
